import {
  GetUserAgency,
  GetUserDoctor,
  GetUserExpert,
  GetUserHospital,
  GetUserMembership,
  GetUserInterestHospital,
  PostRegisterImageRequest,
  PostRegisterImageResponse,
  PutUserAgencyReq,
  PutUserAgencyRes,
  PutUserDoctorReq,
  PutUserDoctorRes,
  PutUserExpertReq,
  PutUserExpertRes,
  PutUserHospitalReq,
  PutUserHospitalRes,
  PostUserRegisterAgencyData,
  PostUserRegisterDoctorData,
  PostUserRegisterExpertData,
  PostUserRegisterHospitalData,
  PostUserRegisterResponse,
  PostUsersRegisterReqest,
  PutUserPasswordReq,
  PutUserPasswordRes,
  DeleteUserRes,
  DeleteFile,
  VerifyNicknameResponse,
  LicenseEncryptResponse,
} from "models/User";
import request from "./core";
import axios from "axios";

export const postUsersRegisterDoctor = ({
  provider,
  data,
}: PostUsersRegisterReqest<PostUserRegisterDoctorData>) => {
  return request.post<PostUserRegisterResponse>(
    `/users/register/${provider}/doctor`,
    data
  );
};

export const postUsersRegisterExpert = ({
  provider,
  data,
}: PostUsersRegisterReqest<PostUserRegisterExpertData>) => {
  return request.post<PostUserRegisterResponse>(
    `/users/register/${provider}/expert`,
    data
  );
};

export const postUsersRegisterHospital = ({
  provider,
  data,
}: PostUsersRegisterReqest<PostUserRegisterHospitalData>) => {
  return request.post<PostUserRegisterResponse>(
    `/users/register/${provider}/hospital`,
    data
  );
};

export const postUsersRegisterAgency = ({
  provider,
  data,
}: PostUsersRegisterReqest<PostUserRegisterAgencyData>) => {
  return request.post<PostUserRegisterResponse>(
    `/users/register/${provider}/agency`,
    data
  );
};

export const PostRegisterImage = ({ type, data }: PostRegisterImageRequest) => {
  return request.post<PostRegisterImageResponse>(
    `/users/register/${type}/file`,
    data
  );
};

export const getUserDoctor = () => {
  return request.get<GetUserDoctor>(`/users/doctor`);
};

export const getUserAgency = () => {
  return request.get<GetUserAgency>(`/users/agency`);
};

export const getUserExpert = () => {
  return request.get<GetUserExpert>(`/users/expert`);
};

export const getUserHospital = () => {
  return request.get<GetUserHospital>(`/users/hospital`);
};

export const getUserMembership = () => {
  return request.get<GetUserMembership>(`/memberships`);
};
export const getUserInterestHospital = () => {
  return request.get<GetUserInterestHospital>(`/hospital/me/interest/hospital`);
};
export const getMyHospital = () => {
  return request.get<GetHospitalDetailResponse>(`/hospital/me/detail`);
};

export const getGeo = (data: string) => {
  console.log(process.env.REACT_APP_KAKAO_CLIENT_ID);
  return axios.get(
    `https://dapi.kakao.com/v2/local/search/address.json?query=${data}`,
    {
      headers: {
        Authorization: `KakaoAK ${process.env.REACT_APP_KAKAO_CLIENT_ID}`,
      },
    }
  );
};

export const putUserDoctor = (data: PutUserDoctorReq) => {
  return request.put<PutUserDoctorRes>(`/users/doctor`, data);
};

export const putUserAgency = (data: PutUserAgencyReq) => {
  return request.put<PutUserAgencyRes>(`/users/agency`, data);
};

export const putUserExpert = (data: PutUserExpertReq) => {
  return request.put<PutUserExpertRes>(`/users/expert`, data);
};

export const putUserHospital = (data: PutUserHospitalReq) => {
  return request.put<PutUserHospitalRes>(`/users/hospital`, data);
};

export const putUserPassword = (data: PutUserPasswordReq) => {
  return request.put<PutUserPasswordRes>("/users/password", data);
};

export const deleteUser = () => {
  return request.delete<DeleteUserRes>("/users/delete");
};
export const deleteFile = (data: DeleteFile) => {
  return request.delete(`/users/files`, { data });
};

export const verifyNickname = (nickname: string) => {
  return request.post<VerifyNicknameResponse>(`/users/verify/nickname`, {
    nickname,
  });
};
export const postEncrypt = (plainText: string) => {
  return request.post<LicenseEncryptResponse>(
    `/users/register/doctor/licence/encrypt`,
    {
      plainText,
    }
  );
};
